<template>
  <div>
      <Header></Header>
      在线课堂
  </div>
</template>

<script>
import Header from '../header';
import Footer from '../footer'
export default {
  name: '',
  data () {
   return {
      
    }
  },
   methods:{

  },
   components:{
    Header,
    Footer
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ketang/live.vue